//import Moment from "moment";

const getCount = (state) => {
	return state.periodicidades.length;
}

const ultimaAtualizacaoListaPeriodicidades = (state) => {
	if (state.ultimaAtualizacaoListaPeriodicidades == null) {
		return true;
	}
	else if(!state.periodicidades)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.periodicidades.length == 0 ||
			hour - state.ultimaAtualizacaoListaPeriodicidades.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaPeriodicidades
}